export function createGoogleMapsPin(store, isLocalStore = false) {
	if (!store) return null;
	return {
		position: {
			lat: store.latitude,
			lng: store.longitude
		},
		icon: '/assets/images/stores/pin.png',
	};
}

export function createGoogleMapsPins(stores, localStore = null) {
	return stores.map(store => {
		const isLocalStore = !!localStore && localStore.id === store.id;
		return createGoogleMapsPin(store, isLocalStore);
	});
}

export function createStoreInfoContent(store) {
	return `
		<div style="font-size: 120%"><strong>${store.cityAlias}, ${store.state}</strong></div>
		<div>${store.address1}</div>
		<div>${store.city}, ${store.state} ${store.zip}</div>
		<div><strong>${store.currentHoursJson.status}</strong></div>
	`;
}

export function getRadiusOfMapView(map) {
	try {
		// https://stackoverflow.com/a/3527136
		const bounds = map.getBounds();
		if (!bounds) return null;
		const center = bounds.getCenter();
		const ne = bounds.getNorthEast();
		const r = 3963.0; // radius of the earth in statute miles

		// Convert lat or lng from decimal degrees into radians (divide by 57.2958)
		const lat1 = center.lat() / 57.2958;
		const lon1 = center.lng() / 57.2958;
		const lat2 = ne.lat() / 57.2958;
		const lon2 = ne.lng() / 57.2958;

		// distance = circle radius from center to Northeast corner of bounds
		return r * Math.acos(Math.sin(lat1) * Math.sin(lat2) +
			Math.cos(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1));
	} catch (e) {
		return null;
	}
}

export function getStorePosition(store) {
	if (!store) return;
	return {
		lat: store.latitude,
		lng: store.longitude
	};
}